import ApiClient from '@afosto/api/ApiClient';

class Search {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * List items
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description List items on handling list
   * @returns {Promise}
   */
  listListItems(body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/search/shipments/items`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * List items
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Search items on handling list
   * @returns {Promise}
   */
  searchHandlingListItems(body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/search/lists/items`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Search a fulfilment location
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Search for a set of fulfilment locations
   * @returns {Promise}
   */
  searchLocations(body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/search/locations`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * List items
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Search parcel items
   * @returns {Promise}
   */
  searchParcelItems(body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/search/parcels/items`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Search a parcel
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Search for a set of parcels
   * @returns {Promise}
   */
  searchParcels(body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/search/parcels`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Search shipment methods
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Search for shipment methods
   * @returns {Promise}
   */
  searchShipmentMethods(body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/search/methods`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Search a shipment
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Search for a set of shipments
   * @returns {Promise}
   */
  searchShipments(body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/search/shipments`,
      method: 'post',
      data: body,
      ...options,
    });
  }
}

export const search = new Search();

export default Search;
